import dayjs from "dayjs";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import type { FirebaseTimestampJsonCompat, TimestampOrDate, TimeUnits } from "../shared/types";

export function timestampToDate(timestamp: FirebaseTimestampJsonCompat) {
    const milliseconds = timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000;
    return new Date(milliseconds);
}

export function compareDates(date1: TimestampOrDate, date2: TimestampOrDate, type: TimeUnits) {
    let cleanDate1: Date;
    let cleanDate2: Date;

    date1 = date1 || new Date("2000-01-01");
    date2 = date2 || new Date("2000-01-01");

    if (date1 instanceof Date) {
        cleanDate1 = date1;
    } else {
        cleanDate1 = timestampToDate(date1);
    }

    if (date2 instanceof Date) {
        cleanDate2 = date2;
    } else {
        cleanDate2 = timestampToDate(date2);
    }

    return dayjs(cleanDate1).diff(cleanDate2, type);
}

export function createMonthOptions(monthsPrevious = 12, monthsFuture = 12) {
    const options: string[] = [];

    for (let m = monthsPrevious; m >= 0; m--) {
        const option = dayjs().subtract(m, "month").format("MMM 'YY");
        options.unshift(option);
    }

    for (let m = 1; m <= monthsFuture; m++) {
        const option = dayjs().add(m, "month").format("MMM 'YY");
        options.unshift(option);
    }

    return options;
}

export function getCurrentMonthDue() {
    return dayjs().set("date", 15).toDate();
}

export function timestampOrDateToDate(
    date: TimestampOrDate,
    asString = true,
    format = "YYYY-MM-DD",
) {
    let parsedDate: Date;
    if (date instanceof Date) {
        parsedDate = date;
    } else {
        parsedDate = timestampToDate(date);
    }

    if (asString) {
        return dayjs(parsedDate).format(format);
    }
    return parsedDate;
}

export function timestampToMonthDue(timestamp: FirebaseTimestampJsonCompat | undefined | null) {
    if (timestamp) {
        const date = timestampToDate(timestamp);
        return dayjs(date).format("MMM 'YY");
    }
    if (typeof timestamp === "string") {
        console.log("STRING!");
        return timestamp;
    }
    return "DEC '99";
}

export function monthDueToTimestamp(monthDue: string | FirebaseTimestampJsonCompat | undefined | null) {
    if (monthDue) {
        let due: string;
        if (typeof monthDue !== "string") {
            due = timestampToMonthDue(monthDue);
        } else {
            due = monthDue;
        }

        const parsedDateString = due.replace("'", "20").replace(" ", " 15 ");
        return new firebase.firestore.Timestamp(new Date(parsedDateString).getTime() / 1000, 0);
    }
    return new firebase.firestore.Timestamp(new Date("Dec 31 2099").getTime() / 1000, 0);
}

export function convertJsonToFirestoreTimestamp(jsonTimestamp: { seconds: number; nanoseconds: number }) {
    return new firebase.firestore.Timestamp(jsonTimestamp.seconds, jsonTimestamp.nanoseconds);
}
